import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reset-password-contact',
  templateUrl: './reset-password-contact.component.html',
  styleUrls: ['./reset-password-contact.component.scss']
})
export class ResetPasswordContactComponent implements OnInit {

  sectionTitle = 'Reset Your Password'
  SIGetHelpInfo = 'Please get in touch with our customer service team who may be able to help you.'

  constructor() { }

  ngOnInit() {
  }

}
